"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformEventListenerHandler = exports.InformableEventName = void 0;
var InformableEventName;
(function (InformableEventName) {
    InformableEventName["AppointmentConfirmed"] = "appointment.confirmed";
    InformableEventName["ProductPurchased"] = "product.purchased";
    InformableEventName["InboundMessage"] = "inbound-message.received";
    InformableEventName["InformAudienceMemberMessageClicked"] = "inform-audience-member-message.clicked";
    InformableEventName["ClinicPetBirthday"] = "clinic-pet.birthday";
    InformableEventName["UserInterfaceInteraction"] = "ui.interaction";
    InformableEventName["DataCaptured"] = "data.captured";
})(InformableEventName = exports.InformableEventName || (exports.InformableEventName = {}));
var InformEventListenerHandler;
(function (InformEventListenerHandler) {
    InformEventListenerHandler["HillsToHomeProductPurchased"] = "handleHillsToHomeProductPurchased";
    InformEventListenerHandler["HillsToHomeLinkClick"] = "handleHillsToHomeLinkClick";
    InformEventListenerHandler["HillsPrescriptionIdAppointmentConfirmed"] = "handleHillsPrescriptionIdAppointmentConfirmed";
    InformEventListenerHandler["HillsPrescriptionIdLinkClick"] = "handleHillsPrescriptionIdLinkClick";
    InformEventListenerHandler["TrupanionExamDayOfferAppointmentConfirmed"] = "handleTrupanionExamDayOfferAppointmentConfirmed";
    InformEventListenerHandler["TrupanionExamDayOfferLinkClick"] = "handleTrupanionExamDayOfferLinkClick";
})(InformEventListenerHandler = exports.InformEventListenerHandler || (exports.InformEventListenerHandler = {}));
//# sourceMappingURL=InformableEventJobInput.js.map